export default __webpack_public_path__ + "static/media/logo.91d00fbf.png";